import React from 'react';
import CountUp from 'react-countup';
import TrackVisibility from "react-on-screen";
import ScrollAnimation from "react-animate-on-scroll";

const Data = [
    {
        countNum : 45,
        countTitle: '完成的项目',
    },
    {
        countNum : 25,
        countTitle: '雇员',
    },
    {
        countNum : 2000000,
        countTitle: '总投入资金',
    },
    {
        countNum : 38,
        countTitle: '总投资的房产数目',
    },
];
const SlipFour = () => {
    return (
        <div className="rn-splite-style bg-color-blackest">
            <div className="split-wrapper">
                <div className="row no-gutters radius-10 align-items-center">
                    <div className="order-2 order-lg-1 col-lg-12 col-xl-6 col-12">
                        <div className="split-inner">
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <h4 className="title">我们的投资公司在过去的一段时间里取得了显著的成就。</h4>
                            </ScrollAnimation>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <p className="description">经过深思熟虑的策略规划和精心的市场分析，我们成功地投资了30多处房产，总投资额超过了200万美元。这些投资不仅涵盖了多个地理位置和不同类型的物业，而且还展现了我们公司在房地产市场上的坚实实力和深厚的洞察力。</p>
                                <p className="description">我们的目标始终是为客户寻找最有价值的投资机会，同时确保风险控制和资金安全。这一系列的投资举措不仅反映了我们对市场动态的敏锐洞察，也是对未来房地产市场充满信心的明证。我们相信，这些投资将为我们的客户带来可观的回报，并进一步巩固我们作为行业领导者的地位。</p>
                            </ScrollAnimation>

                            <div className="row">
                                {Data.map((data, index) => (
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-12" key={index}>
                                        <div className="count-box counter-style-4 text-start">
                                            <TrackVisibility once>
                                                {({ isVisible }) => isVisible && 
                                                    <div className="count-number">{isVisible ? <CountUp end={data.countNum} /> : 0}</div>}
                                            </TrackVisibility>
                                            <h5 className="counter-title">{data.countTitle}</h5>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="order-1 order-lg-2 col-lg-12 col-xl-6 col-12">
                        <div className="thumbnail">
                            <img src="./images/split/split-04.jpg" alt="split Images" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SlipFour;